
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/[version]/[[...slug]]",
      function () {
        return require("private-next-pages/docs/[version]/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/[version]/[[...slug]]"])
      });
    }
  